import React from "react";
import ConfigurationMaster from "./ConfigurationMaster";

function ConfigurationEnvironment() {
    return (
        <ConfigurationMaster
            type="environment"
        />
    );
}

export default ConfigurationEnvironment;